<template>
  <b-modal
    id="alreadyInterview"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    :visible="showAlreadyInterview"
    @hidden="closeModal()"
  >
    <div>
      <div class="d-flex align-items-center justify-content-between p-3">
        <div class="b-modal-header">Already Interviewed?</div>
        <div class="rotate-on-hover pointer">
          <img
            @click="closeModal()"
            v-b-tooltip.hover.top="'Close'"
            src="../../../assets/img/accessconnew/blueCross.svg"
            alt
          />
        </div>
      </div>
      <hr class="my-0" />

      <div class="p-4">
        <div class="position-relative" v-if="showRecOptions">
          <SelectCustom
            :mandatory="true"
            :placeholder="'Select'"
            :values="getFilteredRecOptions"
            :dropdown="true"
            @select-value="
              (alreadyInterview.recOption = $event),
                (alreadyInterview.recommendation =
                  thirdPartyData.configuration.recommendationKey[$event])
            "
            :vmodel="$v.alreadyInterview.recOption.$model"
            :label="'Recommendation'"
            :showError="$v.alreadyInterview.recOption.$error"
          />
          <div v-if="$v.alreadyInterview.recOption.$error" class="error-txt-tc">
            Required
          </div>
        </div>
        <div v-else>
          <div>
            <label class="b-modal-inputs-heading">
              Recommendation
              <span class="asterik">*</span>
            </label>
          </div>
          <div
            :class="
              $v.alreadyInterview.recommendation.$error
                ? 'recomendation-error'
                : ''
            "
            class="d-flex new-center-radio mt-2"
          >
            <b-form-radio-group
              class="radio-class"
              :options="options"
              v-model="$v.alreadyInterview.recommendation.$model"
              value-field="value"
              text-field="name"
              disabled-field="notEnabled"
            ></b-form-radio-group>
          </div>
        </div>
        <hr />
        <div
          v-if="
            alreadyInterview.recommendation == 'S' &&
            !vendor &&
            !checkFirstRound &&
            totalNoOfRounds - 4 != parseInt(toRound)
          "
          :class="
            $v.alreadyInterview.finalRec.$error ? 'recomendation-error' : ''
          "
          class="d-flex new-center-radio mt-2"
        >
          <b-form-radio-group
            class="radio-class"
            :options="anotherOptions"
            value-field="value"
            text-field="name"
            v-model="$v.alreadyInterview.finalRec.$model"
            disabled-field="notEnabled"
          ></b-form-radio-group>
        </div>
        <div class="mt-3" v-if="alreadyInterview.finalRec == 'FS'">
          <SingleSelectSearch
            :label="'Approver (To select this candidate for final selection)'"
            :mandatory="true"
            :showError="$v.alreadyInterview.selectedOpsHead.$error"
            :opsHeadList="opsHeadList"
            @search-data="searchOpsHead"
            @select-value="selOpsHead"
          />
        </div>
        <div class="topDiv mt-3">
          <div>
            <label class="b-modal-inputs-heading">
              Comments
              <span class="asterik">*</span>
            </label>
          </div>
          <div class="mt-1">
            <b-form-textarea
              class="newInt-previewInputField"
              placeholder="Enter"
              rows="3"
              max-rows="4"
              v-model="$v.alreadyInterview.comments.$model"
              :class="$v.alreadyInterview.comments.$error ? 'error' : ''"
            ></b-form-textarea>
            <div
              v-if="
                $v.alreadyInterview.comments.$dirty &&
                !$v.alreadyInterview.comments.required
              "
              class="errortxt mt-1"
            >
              Required
            </div>
            <div
              v-else-if="!$v.alreadyInterview.comments.maxLength"
              class="errortxt mt-1"
            >
              Max char length exceeded
            </div>
          </div>
        </div>
      </div>

      <hr class="my-0" />

      <div class="d-flex align-items-center justify-content-end p-3 w-100">
        <div class="d-flex align-items-center bluebtn">
          <b-button class="acs-cancelBtn-modal mr-3" @click="closeModal()"
            >Cancel</b-button
          >
          <div class="position-relative">
            <b-button
              :class="
                SpinnerStatus ? 'send-loader-class defaultCursor' : 'pointer'
              "
              class="acs-addBtn-modal pl-4 pr-4"
              @click="submitInterviewed()"
              >{{ SpinnerStatus ? "" : "Save" }}</b-button
            >
            <div v-if="SpinnerStatus" class="send-loader-pos">
              <Loader />
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { required, requiredIf, maxLength } from "vuelidate/lib/validators";
import {
  getOpsHead,
  movetofinalround,
  savefeedbackform,
  addScheduleInterview,
} from "../../../utils/apiFunctions";
import SingleSelectSearch from "../../InputComponents/SingleSelectSearch.vue";
import Loader from "../../../components/fixedcomponents/Loader.vue";
import SelectCustom from "../../../components/InputComponents/SelectCustom";
import { getCurrentDate } from "../../../controllers/commonHelpers";
import { mapGetters } from "vuex";
import toast from "../../mixin/toast";

export default {
  name: "AlreadyInterviewed",
  props: {
    showAlreadyInterview: Boolean,
    vendor: Boolean,
    toRound: String,
    totalNoOfRounds: Number,
    vendorRounds: Number,
    candidate: Object,
    particularJob: Object,
    inAddedToJd: Boolean,
  },
  components: {
    SingleSelectSearch,
    Loader,
    SelectCustom,
  },
  mixins: [toast],
  data() {
    return {
      options: [
        {
          value: "S",
          name: "Select",
        },
        {
          value: "H",
          name: "Hold",
        },
        {
          value: "R",
          name: "Reject",
        },
        {
          value: "NI",
          name: "Not Interested",
        },
      ],
      anotherOptions: [
        {
          value: "SE",
          name: "Select for next round",
        },
        {
          value: "FS",
          name: "Select to hire",
        },
      ],
      alreadyInterview: {
        recommendation: null,
        finalRec: null,
        comments: null,
        selectedOpsHead: {},
        recOption: null,
      },
      SpinnerStatus: false,
      showOpsHead: false,
      opsHeadSearch: "",
      opsHeadList: [],
      count: null,
    };
  },
  validations() {
    return {
      alreadyInterview: {
        recommendation: {
          required,
        },
        finalRec: {
          required: requiredIf(() => {
            return (
              this.alreadyInterview.recommendation == "S" &&
              !this.vendor &&
              !this.checkFirstRound &&
              this.totalNoOfRounds - 4 != parseInt(this.toRound)
            );
          }),
        },
        selectedOpsHead: {
          required: requiredIf(() => {
            return this.alreadyInterview.finalRec == "FS";
          }),
        },
        comments: {
          required,
          maxLength: maxLength(124),
        },
        recOption: {
          required: requiredIf(() => {
            return this.showRecOptions;
          }),
        },
      },
    };
  },
  created() {
    this.clearAlreadyInterviewed();
    this.count = this.toRound == 0 ? "5" : "4";
    this.setOptions();
  },
  watch: {
    "alreadyInterview.finalRec"(val) {
      if (val && val == "FS") {
        this.getOpsHead();
      }
      if (val != "FS") {
        this.alreadyInterview.selectedOpsHead = {};
        this.showOpsHead = false;
        this.opsHeadSearch = "";
      }
    },
    "alreadyInterview.recommendation"(val) {
      if (val && val !== "S") this.alreadyInterview.finalRec = null;
      else if (val === "S" && !this.vendor)
        this.alreadyInterview.finalRec = "SE";
    },
  },
  computed: {
    ...mapGetters("userVUEX", {
      licenseKey: "getlicenseKey",
      roleValues: "getRoleValues",
      thirdPartyData: "getThirdPartyData",
    }),
    showRecOptions() {
      if (this.thirdPartyData.configuration?.feedbackTypeID == "FEEDBACK2")
        return true;
      return false;
    },
    getFilteredRecOptions() {
      if (this.showRecOptions) {
        let options = JSON.parse(
          JSON.stringify(this.thirdPartyData.configuration.feedbackLevelOptions)
        );
        delete options["option7"];
        return Object.entries(options).map(([key, label]) => {
          return { key, label };
        });
      }
      return [];
    },
    checkFirstRound() {
      return (
        this.inAddedToJd && this.toRound == 0 && this.totalNoOfRounds - 4 == 1
      );
    },
    checkVendorRounds() {
      if (
        this.totalNoOfRounds - 5 > this.vendorRounds ||
        parseInt(this.toRound) + 1 < this.vendorRounds
      ) {
        return false;
      }
      return true;
    },
  },
  methods: {
    async submitInterviewed() {
      this.$v.alreadyInterview.$touch();
      if (!this.$v.alreadyInterview.$invalid) {
        this.SpinnerStatus = true;
        const val = await this.sendAlreadyInterviewed();
        if (val && val.status == 200) {
          await this.sendFeedback(val.data.data.interviewID);
        } else {
          this.errorModal("Something went wrong!");
          this.SpinnerStatus = false;
        }
      }
    },
    async sendAlreadyInterviewed() {
      try {
        let payload = {
          jobID: this.particularJob.jobID,
          customerID: this.particularJob.customerID,
          candidateID: this.candidate.candidateID,
          roundlevel: this.vendor
            ? parseInt(this.toRound) + 1
            : parseInt(this.toRound),
          scheduleAlreadyInterviewed: true,
        };
        const res = await addScheduleInterview(payload);
        return res;
      } catch (error) {
        return null;
      }
    },
    getCurrentDate() {
      return getCurrentDate(this);
    },
    async sendFeedback(interviewID) {
      try {
        let rec = this.alreadyInterview.recommendation;
        let finalRec = this.alreadyInterview.finalRec;
        if (
          this.alreadyInterview.finalRec &&
          this.alreadyInterview.finalRec == "FS"
        ) {
          rec = "FS";
          finalRec = "SE";
        }
        if (this.options.findIndex((obj) => obj.name == "Final Select") != -1)
          finalRec = null;
        let payload = {
          interviewID: interviewID,
          processedBy: "Recruiter",
          createdBy: this.roleValues.userID,
          createdFor: null,
          name: this.candidate.name,
          evalDate: this.getCurrentDate(),
          modeOfInterview: "f2f",
          experience: this.candidate.experince,
          panelName: "Hire3x Automated System",
          recommendation: rec,
          recruiterRemarks: this.alreadyInterview.comments,
          select: finalRec,
        };
        if (this.showRecOptions) {
          payload.feedbackLevelID = this.alreadyInterview.recOption;
          payload.feedbackTypeID =
            this.thirdPartyData.configuration.feedbackTypeID;
        }
        if (this.$route.params.vendorID)
          payload.vendorID = this.$route.params.vendorID;
        const res = await savefeedbackform(payload);
        if (res.status == 200) {
          if (rec == "FS") {
            let payload2 = {
              candidateID: this.candidate.candidateID,
              customerID: this.particularJob.customerID,
              jobID: this.particularJob.jobID,
              approverUserID: this.alreadyInterview.selectedOpsHead.userID,
              recruiterRemarks: this.alreadyInterview.comments,
            };
            const res = await movetofinalround(payload2);
            if (res.status !== 200) {
              this.errorModal("Something went wrong!");
              this.SpinnerStatus = false;
            }
          }
          if (this.alreadyInterview.recommendation == "R") {
            this.$nextTick(() => {
              var text = `Candidate "${this.candidate.name}" has been rejected`;
              this.dynamicToast("rejected", `Successfully Rejected`, text);
            });
          } else if (this.alreadyInterview.recommendation == "H") {
            this.$nextTick(() => {
              var text = `Candidate "${this.candidate.name}" has been moved to on-hold`;
              this.dynamicToast("onhold", `Moved to On-Hold`, text);
            });
          } else if (this.alreadyInterview.recommendation == "NI") {
            this.$nextTick(() => {
              var text = `Candidate "${this.candidate.name}" has been moved to not-interested`;
              this.dynamicToast(
                "notinterested",
                `Moved to Not-interested`,
                text
              );
            });
          } else if (rec == "FS") {
            this.$nextTick(() => {
              var text = `Candidate "${this.candidate.name}" has been sent for approval.`;
              this.dynamicToast(
                "feedbacksent",
                `Successfully sent feedback`,
                text
              );
            });
          } else {
            this.$nextTick(() => {
              var text = `Feedback has been sent to candidate "${this.candidate.name}"`;
              this.dynamicToast(
                "feedbacksent",
                `Successfully sent feedback`,
                text
              );
            });
          }
          this.$emit("close-modal", true);
        } else if (res.status == 409) {
          this.errorModal(res.data.data.Detail);
          this.SpinnerStatus = false;
        } else {
          this.errorModal("Something went wrong!");
          this.SpinnerStatus = false;
        }
      } catch (error) {
        console.error(error);
        this.errorModal("Something went wrong!");
        this.SpinnerStatus = false;
      }
    },
    setOptions() {
      if (this.vendor) {
        this.options = this.options.map((obj) => {
          if (obj.value == "S") {
            obj.name = !this.checkVendorRounds ? "Select" : "Final Select";
          }
          return obj;
        });
      } else if (
        this.checkFirstRound ||
        this.totalNoOfRounds - 4 == parseInt(this.toRound)
      ) {
        this.options = this.options.map((obj) => {
          if (obj.value == "S") {
            obj.name = "Final Select";
          }
          return obj;
        });
      }
    },
    clearAlreadyInterviewed() {
      this.alreadyInterview = {
        recommendation: null,
        finalRec: null,
        comments: null,
        selectedOpsHead: {},
      };
      this.opsHeadSearch = "";
      this.showOpsHead = false;
      this.$v.alreadyInterview.$reset();
      this.$forceUpdate();
    },
    closeModal() {
      this.clearAlreadyInterviewed();
      this.$emit("close-modal");
    },
    searchOpsHead(value) {
      this.opsHeadSearch = value;
      this.getOpsHead();
    },
    selOpsHead(opsHead) {
      this.alreadyInterview.selectedOpsHead = opsHead;
      this.$forceUpdate();
    },
    async getOpsHead() {
      let payload = {
        licenseKey: this.licenseKey,
        searchQuery: this.opsHeadSearch,
      };
      const res = await getOpsHead(payload);
      if (res.status == 200) {
        this.opsHeadList = res.data.data;
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.newInt-previewInputField.form-control {
  font-weight: 500;
  color: #333;
}
</style>
